export default function (source, length = 3) {
  source = String(source).split(".");
  source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{'+length+'})+$)','ig'),"$1,");
  return source.join(".");
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/tools/number/comma.js